"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.join.js");

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var matchRules = {
  FUZZY: ['FULL', 'LEFT', 'RIGHT'],
  EXACT: ['EQ', 'NEQ', 'NIN', 'IN'],
  NULL_VALUE: ['IS_NULL', 'NOT_NULL'],
  RANGE: ['LT', 'LE', 'GT', 'GE', 'BETWEEN'],
  COMPOSITE: ['AND', 'OR']
};
var resolveMatch = {
  FUZZY: function FUZZY(type, fieldName, matchRule, value) {
    var fieldNameArr = [];

    if ((0, _isArray["default"])(fieldName)) {
      fieldNameArr = fieldName;
    } else {
      fieldNameArr = [fieldName];
    }

    return {
      type: type,
      fieldNameArr: fieldNameArr,
      value: value,
      matchRule: matchRule
    };
  },
  EXACT: function EXACT(type, fieldName, matchRule, value) {
    var valueArr = [];

    if ((0, _isArray["default"])(value)) {
      valueArr = value;
    } else {
      valueArr = [value];
    }

    return {
      type: type,
      fieldName: fieldName,
      valueArr: valueArr,
      matchRule: matchRule
    };
  },
  NULL_VALUE: function NULL_VALUE(type, fieldName, matchRule) {
    if (!(0, _isString["default"])(fieldName)) {
      throw new Error("".concat(type, " \u7C7B\u578B\u67E5\u8BE2\u5339\u914D\u5B57\u6BB5\u540D\u79F0\u4E3A\u5B57\u7B26\u4E32"));
    }

    return {
      type: type,
      fieldName: fieldName,
      matchRule: matchRule
    };
  },
  RANGE: function RANGE(type, fieldName, matchRule, value) {
    if (!(0, _isString["default"])(fieldName)) {
      throw new Error("".concat(type, " \u7C7B\u578B\u67E5\u8BE2\u5339\u914D\u5B57\u6BB5\u540D\u79F0\u4E3A\u5B57\u7B26\u4E32"));
    }

    return {
      type: type,
      fieldName: fieldName,
      firstValue: value[0],
      secondValue: value[1],
      matchRule: matchRule
    };
  },
  COMPOSITE: function COMPOSITE(type, fieldName, matchRule, value) {
    return {
      type: type,
      matchArr: resolveMatch[type](type, fieldName, matchRule, value),
      matchRule: matchRule
    };
  }
};

var validateMatchRule = function validateMatchRule(type, matchRule) {
  var rules = matchRules[type];

  if (!(0, _includes["default"])(rules, matchRule)) {
    throw new Error('配置查询匹配规则不对，正确匹配值为：' + rules.join('or'));
  }
};

var validateType = function validateType(type) {
  var match = resolveMatch[type];

  if (!match) {
    throw new Error('不支持此规则查询, type:' + type);
  }
};

function resolveSearchItemRule(_ref) {
  var type = _ref.type,
      fieldName = _ref.fieldName,
      matchRule = _ref.matchRule,
      value = _ref.value;
  validateType(type);
  validateMatchRule(type, matchRule);
  return resolveMatch[type](type, fieldName, matchRule, value);
}

function resolvePage() {
  var queryItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var normalQueryItems = [];
  (0, _forEach["default"])(queryItems, function (item) {
    var type = item.type,
        fieldName = item.fieldName,
        matchRule = item.matchRule,
        value = item.value;
    normalQueryItems.push(resolveSearchItemRule(type, fieldName, matchRule, value));
  });
}

exports.resolveSearchItemRule = resolveSearchItemRule;
exports.resolvePage = resolvePage;